var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBearButterfly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 35H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 43.9999V44.4999H61H37.207H36.8764L36.7469 44.1956L32.9215 35.202L26.4805 21.1569L19.4472 35.2235L19.309 35.4999H19H14H13.1836L13.5546 34.7727L26.0546 10.2727L26.5258 9.34912L26.9551 10.2929L38.0997 34.7929L38.1042 34.8031L40.3298 39.9999H61H61.5V40.4999V43.9999Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4982 44V44.5H60.9982H37.2052H36.8746L36.7451 44.1957L32.917 35.1957L32.6211 34.5H33.3771H37.6427H37.9725L38.1024 34.8032L40.328 40H60.9982H61.4982V40.5V44Z",
    fill: "#E94C69",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.5V53.5",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 44.5H15.3249L15.4569 44.2031L19.4569 35.2031L19.7694 34.5H19H14H13.678L13.5448 34.7931L11.178 40H7H6.5V40.5V44V44.5H7H15Z",
    fill: "#E94C69",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBearButterfly);
export default __webpack_public_path__ + "static/media/bear_butterfly.402d02cbdf81c3046a4e326849110666.svg";
export { ForwardRef as ReactComponent };